import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.resources')
  .factory('$scheduleBinding', scheduleBindingFactory);

function scheduleBindingFactory($bringozFactory: $bringozFactory,
                                scheduleBindingApi: BringozApi,
                                ScheduleBinding_DS: DataStoreConfig) {

  function $scheduleBinding(id: string) {
    return $bringozFactory(id, scheduleBindingApi, ScheduleBinding_DS)
  }

  return $scheduleBinding
}
